import React from 'react';
import { Link } from 'react-router-dom';
import TableHeader from '../../shared/components/tableHeader/TableHeader';
import ContractActions from './ContractActions';
import { CONTRACT_TYPES, formatDate, statusBadge, validityText } from './contractLabels';

// Tabla de contratos del administrador; showUser = incluir la columna del usuario
const ContractsTable = ({ contracts, showUser = true, sensors, onChanged, emptyText = 'No hay contratos' }) => {
    const headers = [
        ...(showUser ? ['Usuario'] : []),
        'Sensor', 'Tipo', 'Estado', 'Vigencia', 'Inicio', 'Vendedor', 'Acciones',
    ];

    return (
        <div className="relative overflow-x-auto shadow-lg sm:rounded-lg">
            <table className="w-full text-sm text-left border border-gray-200">
                <TableHeader headerOptions={headers} />
                <tbody>
                    {contracts.length === 0 && (
                        <tr className="bg-gray-50 border-b text-gray-800">
                            <td colSpan={headers.length} className="text-center px-6 py-3">{emptyText}</td>
                        </tr>
                    )}
                    {contracts.map((c) => {
                        const badge = statusBadge(c);
                        return (
                            <tr key={c.id} className="bg-gray-50 border-b text-gray-800 hover:bg-gray-100 align-top">
                                {showUser && (
                                    <td className="px-6 py-3">
                                        <Link to={`/users/${c.userEmail}`} className="text-blue-600 hover:underline">
                                            {c.userName || c.userEmail}
                                        </Link>
                                        {c.userName && <div className="text-xs text-gray-500">{c.userEmail}</div>}
                                    </td>
                                )}
                                <td className="px-6 py-3 whitespace-nowrap">
                                    {c.sensorId}
                                    {c.sensorName && <div className="text-xs text-gray-500">{c.sensorName}</div>}
                                </td>
                                <td className="px-6 py-3">{CONTRACT_TYPES[c.type] || c.type}</td>
                                <td className="px-6 py-3">
                                    <span className={`px-2 py-1 rounded text-xs font-semibold whitespace-nowrap ${badge.className}`}>
                                        {badge.label}
                                    </span>
                                </td>
                                <td className="px-6 py-3">
                                    {validityText(c)}
                                    {c.validUntil && <div className="text-xs text-gray-500">Hasta {formatDate(c.validUntil)}</div>}
                                </td>
                                <td className="px-6 py-3 whitespace-nowrap">{formatDate(c.startDate)}</td>
                                <td className="px-6 py-3 text-xs">{c.sellerEmail || '-'}</td>
                                <td className="px-6 py-3">
                                    <ContractActions contract={c} sensors={sensors} onChanged={onChanged} />
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};

export default ContractsTable;
